export default __webpack_public_path__ + "static/media/video-locked.28dbd1e9.png";